// Copyright 1999-2017. Plesk International GmbH. All rights reserved.

import { Form } from './form';

/**
 * @class Jsw.form.Login
 * @extends Jsw.form.Form
 */
export const Login = Class.create(Form, {
    _initComponentElement($super) {
        $super();

        const content = '' +
            '<div id="loginSection-username-form-row" class="form-row">' +
                `<div class="field-name"><label for="loginSection-username">${this.lmsg('loginLabel')}&nbsp;</label></div>` +
                '<div class="field-value">' +
                    '<input type="text"' +
                        ` name="${this._getConfigParam('loginInputName', '')}"` +
                        ` id="loginSection-username" value="${this._getConfigParam('loginNameValue', '')}"` +
                        ' class="input-text"' +
                    ' />' +
                '</div>' +
            '</div>' +

            '<div id="loginSection-password-form-row" class="form-row" >' +
                `<div class="field-name"><label for="loginSection-password">${this.lmsg('passwdLabel')}&nbsp;</label></div>` +
                '<div class="field-value">' +
                    `<input type="password" name="${this._getConfigParam('passwdInputName', '')}" id="loginSection-password" value="" class="input-text" />` +
                '</div>' +
            '</div>' +

            '<div class="form-row">' +
                `<div class="field-name"><label for="fid-locale">${this.lmsg('localeLabel')}&nbsp;</label></div>` +
                `<div class="field-value">${this._getConfigParam('localeSelect', '')}</div>` +
            '</div>';

        this._componentElement.update(
            '<div id="loginSection" class="form-box">' +
                `<div id="loginSection-content-area">${this._getConfigParam('warnings', '')}${content}</div>` +
            '</div>' +

            '<div class="btns-box">' +
                '<div class="box-area">' +
                    '<div class="form-row">' +

                        '<div class="field-name">' +
                            `<a href="/get_password.php">${this.lmsg('forgotPasswordLabel')}</a>` +
                            '<br />' +
                            `<a data-type="cookie-policy-preferences-toggle">${this.lmsg('cookies')}</a>` +
                        '</div>' +
                        '<div class="field-value">' +
                            '<span id="btn-send" class="btn">' +
                                `<button type="submit" value="" name="send">${this.lmsg('loginButtonLabel')}</button>` +
                            '</span>' +

                            '<input type="image" src="/theme/images/blank.gif" style="border: 0; height: 0; width: 0; position: absolute; left: -9999px;"/>' +
                        '</div>' +
                    '</div>' +
                '</div>' +
            '</div>'
        );

        this._componentElement.down(`#fid-${this._getConfigParam('loginSelectName', '')}`).observe('change', function () {
            this._componentElement._formSubmit();
        }.bind(this));
    },

    render($super) {
        $super();

        this._componentElement.down('#loginSection-username').focus();
        this._componentElement.down('#loginSection-username').select();
    },

    _onSubmit($super) {
        if (this._componentElement.down('#loginSection-username').value === ''
            || this._componentElement.down('#loginSection-password').value === ''
        ) {
            // eslint-disable-next-line no-alert
            alert(this.lmsg('enterLoginAndPasswd'));
            this._componentElement.down('#loginSection-username').focus();
            this._componentElement.down('#loginSection-username').select();
            return;
        }

        $super();
    },
});



// WEBPACK FOOTER //
// ./jsw/form/login.js